import { render, staticRenderFns } from "./SalesOrder.vue?vue&type=template&id=043784a4&scoped=true"
import script from "./SalesOrder.vue?vue&type=script&lang=ts"
export * from "./SalesOrder.vue?vue&type=script&lang=ts"
import style0 from "./SalesOrder.vue?vue&type=style&index=0&id=043784a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043784a4",
  null
  
)

export default component.exports